import {classNames, IconNames, layout, MaterialIcon, PushButton, theme, typography, View} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback, useEffect, useState} from "react";
import {stylesheet} from "typestyle";
import {useLocalization} from "../../i18n";

interface BookingCodeDisplayProps {
    onNext: () => any;
    onBack: () => any;
    code: string;
}

export function BookingCodeDisplay({onNext, onBack, code}: BookingCodeDisplayProps) {
    const {t} = useLocalization();
    const [reveal, setReveal] = useState(false);
    const [wasRevealed, setWasRevealed] = useState(false);

    useEffect(() => {
        if (reveal) {
            setWasRevealed(true)
        }
    }, [reveal]);

    const handleRevealToggle = useCallback(() => setReveal(!reveal), [reveal]);

    return (
        <View className={classNames(layout.vertical, layout.paddingLarge, layout.spaceBetween)}>
            <div className={classNames(layout.horizontal, layout.center)}>
                <div className={classNames(theme.lessContrast, layout.vertical, layout.spaceBetween, styles.boxLeft)}>
                    <div className={styles.title}>
                        {t("BookingDisplayBookingCode")}
                    </div>
                    <p>
                        {t("BookingDisplayBookingCodeDescription")}
                    </p>
                    <div className={classNames(layout.horizontal, layout.center, layout.alignCenter, styles.icons)}>
                        <div className={classNames(styles.iconContainer, typography.alignCenter)}>
                            <div className={styles.icon}>
                                <MaterialIcon icon={IconNames.photo_camera}/>
                            </div>
                            <div className={styles.iconText}>{t("BookingCodeTakePhoto")}</div>
                        </div>
                        <div>
                            {t("Or")}
                        </div>
                        <div className={classNames(styles.iconContainer, typography.alignCenter)}>
                            <div className={styles.icon}>
                                <MaterialIcon icon={IconNames.create}/>
                            </div>
                            <div className={styles.iconText}>{t("BookingCodeTakeNote")}</div>
                        </div>
                    </div>
                    <div>
                        {t("BookingDisplayBookingCodeInfo")}
                    </div>
                </div>
                <div className={classNames(theme.moreContrast, layout.vertical, layout.center, layout.alignCenter, layout.paddingLarge)}>
                    <div>{t("BookingYourBookingCode")}</div>
                    <div className={classNames(theme.moreContrast, styles.codeContainer)}>
                        <div className={classNames(styles.code, reveal ? styles.codeRevealed : styles.codeHidden)}>
                            {code}
                        </div>
                    </div>
                    <PushButton primary={!wasRevealed} onClick={handleRevealToggle}>
                        {reveal ? t("Hide") : t("Reveal")}
                    </PushButton>
                </div>
            </div>
            <div className={classNames(layout.horizontal, layout.spaceBetween)}>
                <PushButton onClick={onBack}>{t("Back")}</PushButton>
                <PushButton primary={wasRevealed} onClick={onNext}>{t("Next")}</PushButton>
            </div>
        </View>
    );
}

const styles = stylesheet({
    title: {
        fontSize: "1.5em",
    },
    boxLeft: {
        width: "26em",
        padding: "1.5em"
    },
    icons: {
        margin: "1rem 0 2rem 0",
    },
    iconContainer: {
        margin: "0 1.5rem",
        flex: "1",
    },
    icon: {
        fontSize: "3rem",
        lineHeight: 1,
    },
    iconText: {
        fontSize: "1.25rem",
        fontWeight: 500,
    },
    codeContainer: {
        border: "1px solid var(--color-separator)",
        borderRadius: "0.25rem",
        padding: "1rem 2rem",
        margin: "1rem"
    },
    code: {
        fontSize: "2em",
        fontWeight: 700,
        transition: "0.5s filter",
    },
    codeRevealed: {
        filter: "none",
    },
    codeHidden: {
        filter: "blur(0.2em)",
    },
});